import EventsCalendar from "components/investorrelations/EventsCalendar";
import EventsCalendarList from "components/investorrelations/EventsCalendarList";
import type { EventsCalendarState } from "components/investorrelations/EventsCalendarLocalState";
import RightSideFilters, { RightSideFiltersEnum } from "components/investorrelations/RightSideFilters";
import type { IIssuerType } from "types/graphqlTypes";

interface CalendarContentProps extends EventsCalendarState {
  tickerSymbol: string;
  isRenderPageDefault: boolean;
  issuerType: IIssuerType;
}

export default function CalendarContent({
  tickerSymbol,
  isRenderPageDefault,
  issuerType,
  ...filterState
}: CalendarContentProps) {
  return (
    <EventsCalendar
      {...filterState}
      issuerType={issuerType}
      searchQuery={tickerSymbol}
      limit={isRenderPageDefault ? 5 : 20}
    >
      {({ data, error, loading, isLoadingMore, loadMoreEvents }) => {
        return (
          <>
            <div className="col-span-12 row-start-2 space-y-4 lg:col-span-8 lg:row-start-1">
              <EventsCalendarList
                {...filterState}
                eventsCalendar={data}
                searchQuery={tickerSymbol}
                loading={loading}
                isLoadingMore={isLoadingMore}
                loadMoreEvents={loadMoreEvents}
                error={error}
              />
            </div>

            <div className="col-span-12 space-y-4 lg:col-span-4">
              <RightSideFilters
                {...filterState}
                eventsCalendar={data}
                issuerType={issuerType}
                className="sm:relative sm:top-0"
                enableFilters={[
                  RightSideFiltersEnum.EventType,
                  RightSideFiltersEnum.FilterRange,
                  RightSideFiltersEnum.MonthViewCalendar,
                ]}
              />
            </div>
          </>
        );
      }}
    </EventsCalendar>
  );
}
